enum ExceptionTypeEnum {
	platformComponentElement = 'platformComponentElement',
	platform = 'platform',
	componentElement = 'componentElement',
	component = 'component',
	service = 'service',
	generic = 'generic',
	serverErrorResponse = 'serverErrorResponse',
	connectionProblem = 'connectionProblem',
	unableToParseServerResponse = 'unableToParseServerResponse',
	/**
	 * @deprecated This exception type is not being used by any service and will
	 * be removed in the future along with InvalidZipCodeException.
	 */
	invalidZipCode = 'invalidZipCode',
	shoppingCart = 'shoppingCart'
}

export default ExceptionTypeEnum;
